const FORMATTED_AMOUNT_PLACEHOLDER = '\uE000';
export function splitFormattedAmountLabel(translate, key, interpolationKey) {
  if (interpolationKey === void 0) {
    interpolationKey = 'formattedAmount';
  }
  const template = translate(key, {
    [interpolationKey]: FORMATTED_AMOUNT_PLACEHOLDER
  });
  const [prefix = '', suffix = ''] = template.split(FORMATTED_AMOUNT_PLACEHOLDER);
  return {
    prefix,
    suffix
  };
}
//# sourceMappingURL=splitFormattedAmountLabel.js.map